/**
 * The asset CDN, in one place.
 *
 * The host was written out at ~60 call sites across the app plus a few in this
 * package, so a CDN move meant a find-and-replace and hoping none were missed.
 * Web reads its own base from `VITE_APP_ASSETS_BASE_URL` at build time; this is
 * the default everything else uses.
 */
export const ASSETS_BASE_URL = "https://assets.easysbc.io";
/** `assetUrl("fc26/clubs/5.png")` → the full CDN URL. */
export const assetUrl = (path) => `${ASSETS_BASE_URL}/${path.replace(/^\//, "")}`;
/** The website, for links out of the app. */
export const WEB_APP_URL = "https://www.easysbc.io";
/** The evolution states guide, on the website; the app links out to it. */
export const EVOLUTION_STATES_GUIDE_PATH = "/evolutions/tracker";
//# sourceMappingURL=assets.js.map